/**
 * Dev-only: evict stale production service workers before any chunk import.
 *
 * A SW registered from a prior prod/preview visit intercepts `/player/chunks/*`
 * on localhost and serves broken cache entries — dynamic `import('./pulse-app')`
 * never resolves and the boot watchdog fires after 25s.
 *
 * One controlled reload after unregister releases the controlling worker.
 */

const RELOAD_FLAG = 'pulse-dev-sw-cleared';

export async function prepareDevServiceWorker(): Promise<boolean> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return true;
  }
  const hadController = Boolean(navigator.serviceWorker.controller);
  try {
    const regs = await navigator.serviceWorker.getRegistrations();
    for (const reg of regs) {
      await reg.unregister();
    }
  } catch (e) {
    console.warn('[pulse-dev] failed to unregister service workers:', e);
  }
  if (hadController && !sessionStorage.getItem(RELOAD_FLAG)) {
    sessionStorage.setItem(RELOAD_FLAG, '1');
    location.reload();
    return false;
  }
  sessionStorage.removeItem(RELOAD_FLAG);
  return true;
}
